<template>
  <Component :is="typeof $route.meta.layout === 'function' ? $route.meta.layout() : $route.meta.layout">
    <RouterView />
  </Component>
  <AiAssistantWidget v-if="showAiAssistantWidget" />
  <HelpDrawer />
  <WLoading />
  <ConfirmationPane />
  <WTooltip />
  <SdfToastContainer />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';
import AiAssistantWidget from '@/ai-assistant/components/ai-assistant-widget/ai-assistant-widget.vue';
import { useAiAssistantWidget } from '@/ai-assistant/composables/useAiAssistantWidget';
import ConfirmationPane from '@/components/confirmation-pane/confirmation-pane.vue';
import WLoading from '@/components/w-loading/w-loading.vue';
import WTooltip from '@/components/w-tooltip/w-tooltip.vue';
import { useIdleSessionTimeout } from '@/composables/useIdleSessionTimeout';
import { useOidcIdleGuard } from '@/composables/useOidcIdleGuard';
import { useHelpStore } from '@/stores/help';
import SdfToastContainer from '@/waypoint-vue-wrappers/sdf-alert-toast/sdf-alert-toast-container.vue';

defineOptions({
  name: 'App',
});

// Data
const helpStore = useHelpStore();
const { showAiAssistantWidget } = useAiAssistantWidget();
useIdleSessionTimeout();
useOidcIdleGuard();

// Async components
const HelpDrawer = defineAsyncComponent(async () => {
  helpStore.loading = true;
  const helpDrawer = await import('@/help/components/help-drawer.vue');
  helpStore.loading = false;

  return helpDrawer;
});
</script>
